import axios from 'axios';
import { ACCESS_TYPE, VENDING_URL } from '../../atoms/const';
import getAllRes from './getAll.json';
import getAislesByWarehouseIdRes from './getAislesByWarehouseId.json';
import getAislesByNameAndLevelRes from './getAislesByNameAndLevel.json';

const getAll = () => {
  const token = sessionStorage.getItem('token');
  const url = `${VENDING_URL}get-all-warehouses`;
  const config = {
    headers: { Authorization: `${ACCESS_TYPE} ${token}` },
  };
  return axios.get<typeof getAllRes>(url, config);
};

const getAislesByWarehouseId = (warehouseId: number) => {
  const token = sessionStorage.getItem('token');
  const url = `${VENDING_URL}get-warehouse-aisles?id=${warehouseId}`;
  console.log('Warehouse: ', url);
  const config = {
    headers: { Authorization: `${ACCESS_TYPE} ${token}` },
  };
  return axios.get<typeof getAislesByWarehouseIdRes>(url, config);
};

const findItemsBySearch = (warehouseId: number, search: string) => {
  const token = sessionStorage.getItem('token');
  const url = `${VENDING_URL}find-item?warehouseId=${warehouseId}&q=${search}`;
  const config = {
    headers: { Authorization: `${ACCESS_TYPE} ${token}` },
  };
  return axios.get(url, config);
};

const getAislesByNameAndLevel = (warehouseId: number, aisleName: string, level: number) => {
  const token = sessionStorage.getItem('token');
  const url = `${VENDING_URL}get-aisle-level?name=${aisleName}&level=${level}&warehouseId=${warehouseId}`;
  const config = {
    headers: { Authorization: `${ACCESS_TYPE} ${token}` },
  };
  return axios.get<typeof getAislesByNameAndLevelRes>(url, config);
};

interface AddData {
  'name': string;
  'addressTheSame': boolean;
  'address': {
    'streetAddress': string;
    'zipCode': string;
    'city': string;
    'state': string;
  }
}

interface UpdateData {
  'id': number;
  'name': string;
  'addressTheSame': boolean;
  'address': {
    'streetAddress': string;
    'zipCode': string;
    'city': string;
    'state': string;
  }
}

const add = (data: AddData) => {
  const token = sessionStorage.getItem('token');
  const url = `${VENDING_URL}add-warehouse`;
  const config = {
    headers: { Authorization: `${ACCESS_TYPE} ${token}` },
  };
  return axios.post(url, { ...data }, config);
};

const update = (data: UpdateData) => {
  const token = sessionStorage.getItem('token');
  const url = `${VENDING_URL}update-warehouse`;
  const config = {
    headers: { Authorization: `${ACCESS_TYPE} ${token}` },
  };
  return axios.post(url, { ...data }, config);
};

interface AddAisleData {
  'warehouseId': number;
  'name': string;
  'level': number;
}

const addAisle = (data: AddAisleData) => {
  const token = sessionStorage.getItem('token');
  const url = `${VENDING_URL}add-aisle`;
  const config = {
    headers: { Authorization: `${ACCESS_TYPE} ${token}` },
  };
  return axios.post(url, { ...data }, config);
};

interface UpdateAisleData {
  'warehouseId': number;
  'name': string;
  'newName': string;
}

const updateAisle = (data: UpdateAisleData) => {
  const token = sessionStorage.getItem('token');
  const url = `${VENDING_URL}update-aisle`;
  const config = {
    headers: { Authorization: `${ACCESS_TYPE} ${token}` },
  };
  return axios.post(url, { ...data }, config);
};

const removeItem = (id: number) => {
  const token = sessionStorage.getItem('token');
  const url = `${VENDING_URL}remove-item`;
  const config = {
    headers: { Authorization: `${ACCESS_TYPE} ${token}` },
  };
  return axios.post(url, { id }, config);
};

const removeAllItemFromLevel = (id: number) => {
  const token = sessionStorage.getItem('token');
  const url = `${VENDING_URL}remove-all-items-from-level`;
  const config = {
    headers: { Authorization: `${ACCESS_TYPE} ${token}` },
  };
  return axios.post(url, { id }, config);
};

interface PlaceItemData {
  aisleId: number;
  productId: number;
  next?: {
    id: number;
    sortOrder: number;
  },
  prev?: {
    id: number;
    sortOrder: number;
  }
}

const placeItem = (data: PlaceItemData) => {
  const token = sessionStorage.getItem('token');
  const url = `${VENDING_URL}place-item`;
  const config = {
    headers: { Authorization: `${ACCESS_TYPE} ${token}` },
  };
  return axios.post(url, { ...data }, config);
};

interface MoveItemData {
  itemId: number;
  next?: {
    id: number;
    sortOrder: number;
  },
  prev?: {
    id: number;
    sortOrder: number;
  }
}

const moveItem = (data: MoveItemData) => {
  const token = sessionStorage.getItem('token');
  const url = `${VENDING_URL}move-item`;
  const config = {
    headers: { Authorization: `${ACCESS_TYPE} ${token}` },
  };
  return axios.post(url, { ...data }, config);
};

const warehouse = {
  getAll,
  getAislesByWarehouseId,
  getAislesByNameAndLevel,
  add,
  update,
  addAisle,
  updateAisle,
  removeItem,
  removeAllItemFromLevel,
  placeItem,
  moveItem,
  findItemsBySearch,
};

export default warehouse;
